import { GetterTree } from 'vuex'

import { ItemGroup } from '@/models'

import { orderByLocale } from '@/utils'

import { RootState } from '../../state'
import { MenuState } from '../state'

const getters: GetterTree<MenuState, RootState> = {
  /**
   * Returns an ItemGroup by its id, or null if not found.
   *
   * @param id ItemGroup id to be found.
   */
  itemGroupById: (state) => (id: number): ItemGroup | null => {
    return state.itemGroups.elements.find((i) => i.id === id) || null
  },

  /**
   * Returns ItemGroups ordered by title.
   */
  orderedItemGroups (state): ItemGroup[] {
    return orderByLocale(state.itemGroups.elements, 'title')
  }
}

export default getters
